// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c7e15254","732":"d4883b96","977":"7e3c905a"}[chunkId] + ".chunk.js";
};